import { topics } from '@/mocks/homepage';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            话题标签
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            按话题标签浏览感兴趣的漫画讨论，找到同好圈
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#cards');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${topic.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-900">{topic.name}</span>
              <span className="text-[11px] text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}